import { Routes } from '@angular/router'
import { requirementsGuard } from '@core/guards/requirements.guard'
import { authGuard } from '@core/guards/auth.guard'
import { guestGuard } from '@core/guards/guest.guard'
import { pendingRequirementsGuard } from '@core/guards/pending-requirements.guard'

export const routes: Routes = [
  {
    path: 'welcome',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/welcome-page/welcome-page.component').then(m => m.WelcomePageComponent)
  },
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadChildren: () => import('./auth/auth.routes').then(m => m.routes)
  },
  {
    path: 'verify_email',
    canActivate: [authGuard, pendingRequirementsGuard],
    loadComponent: () => import('./pages/verify-email-page/verify-email-page.component').then(m => m.VerifyEmailPageComponent)
  },
  {
    path: 'avisodeprivacidad',
    loadComponent: () => import('./pages/aviso-privacidad-page/aviso-privacidad-page.component').then(m => m.AvisoPrivacidadPageComponent)
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [authGuard],
    canActivateChild: [requirementsGuard],
    children: [
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
      },
      {
        path: 'coins',
        loadComponent: () => import('./pages/coins-page/coins-page.component').then(m => m.CoinsPageComponent)
      },
      {
        path: 'tienda',
        loadChildren: () => import('./features/prizes/prizes.routes').then(m => m.routes)
      },
      {
        path: 'misiones',
        loadChildren: () => import('./features/missions/missions.routes').then(m => m.missionsRoutes)
      },
      {
        path: 'ranking',
        loadChildren: () => import('./features/ranking/ranking.routes').then(m => m.rankingRoutes)
      },
      {
        path: 'encuestas',
        loadChildren: () => import('./features/encuestas/encuestas.routes').then(m => m.routes)
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile-page/profile-page.component').then(m => m.ProfilePageComponent)
      },
      {
        path: 'faq',
        loadComponent: () => import('./pages/faq-page/faq-page.component').then(m => m.FaqPageComponent)
      },
      {
        path: 'terms',
        loadComponent: () => import('./pages/terms-page/terms-page.component').then(m => m.TermsPageComponent)
      }
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
  },
  {
    path: '**',
    redirectTo: '/404'
  }
]
